<script setup>
import {useRoute} from "vue2-helpers/vue-router";
import needsService from "@/services/needs.service";
import {ref, onMounted, provide} from "vue";
import needsStartupsService from "@/services/needs-startups.service";
import {getNoun} from "../../helpers/string";
import MatchMakingModal from "@/views/needs/MatchMakingModal.vue";

const route = useRoute();
const need = ref(null);
const startups = ref([]);
const matchMakingModal = ref(null);

onMounted(() => {
    getInfo();
    getStartups();
});

async function getInfo() {
    const {data} = await needsService.getInfo(route.params.id);
    need.value = data;
}

async function getStartups() {
    const {data} = await needsStartupsService.getStartups(route.params.id);
    startups.value = data;
}

async function getNewAiMatches() {
    await needsStartupsService.getNewAiMatches(route.params.id);
    await getStartups();
}

provide('needId', route.params.id);
</script>

<template>
    <div v-if="need" class="need-page">
        <div class="card-needs">
            <div class="card-needs__content card-needs__content--columns">
                <div>
                    <h5 class="heading5 heading5--secondary">{{need.name}}</h5>
                    <p>{{need.description}}</p>

                    <div class="btn-xl-wrapper">
                        <a href="#" class="btn-xl btn-xl-bordered btn-xl-edit">Refine Need</a>
                        <a href="#" class="btn-xl btn-xl-export">Escalate Need</a>
                    </div>
                </div>

                <div class="card-needs__sidebar">
                    <ul class="list-plan">
                        <li class="list-plan__done">Add AI-suggested solutions</li>
                        <li class="list-plan__done">Add ecosystem recommendations</li>
                        <li>Rate all your solutions</li>
                        <li>Escalate need to innovation team</li>
                    </ul>
                </div>
            </div>
            <footer class="card-needs__footer">
                <p><b>Escalate</b> to send this need and your assessed solutions to your innovation team for further review</p>
            </footer>
        </div>

        <div class="need-page__content">
            <aside class="need-page__aside">
                <div class="card-headline">
                    <header class="card-headline__header">Summary Report</header>

                    <div class="card-headline__inner">
                        <img src="https://sp-images-prod.s3.amazonaws.com/knowledge-base-images/image%286%29.png" alt="" />
                    </div>
                    <footer class="card-headline__footer">
                        <a href="#" class="link link--view d-flex justify-content-end">View</a>
                    </footer>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Activity</header>

                    <div class="card-headline__content">
                        <ul class="need-list-activity">
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                            <li><span>Removed <a href="#">Gamma Core</a></span></li>
                            <li><span>Disliked <a href="#">Eta Foods</a></span></li>
                            <li class="need-list-activity__like"><span>Liked <a href="#">Gamma Core</a></span></li>
                        </ul>

                        <div class="text-center">
                            <a href="#" class="link">Load More</a>
                        </div>
                    </div>
                </div>

                <div class="card-headline">
                    <header class="card-headline__header">Settings</header>

                    <div class="card-headline__content">


                        <div class="content-switcher content-switcher--tertiary">
                            AI solution recommendations
                            <div class="content-switcher__slider">
                                <input type="checkbox" id="hidden-for-startups-switcher__slider">
                                <label for="hidden-for-startups-switcher__slider"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>

            <div class="need-page__inner">
                <div class="card-needs mb-5">
                    <header class="card-needs__header">
                        <h3 class="heading3 heading3--match">New Matches</h3>
                    </header>
                    <div class="card-needs__content">
                        <div class="row">
                            <div v-if="need.unreviewed_startups_count" class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <div class="card-needs__notification card-needs__notification--active">
                                            <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                                        </div>

                                        <div class="text-center">
                                            <div class="card-needs__plate">{{need.unreviewed_startups_count}} new AI {{getNoun('recommendation')}}</div>
                                        </div>
                                    </div>

                                    <footer class="card-headline__footer">
                                        <a @click="matchMakingModal?.open()" class="link-arrow justify-content-end">Review</a>
                                    </footer>
                                </div>
                            </div>

                            <div class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <div class="card-needs__notification card-needs__notification--active">
                                            <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="" />
                                        </div>

                                        <div class="text-center">
                                            <div class="card-needs__plate">NEA sent 6 solutions</div>
                                        </div>
                                    </div>
                                    <footer class="card-headline__footer">
                                        <a href="#" class="link-arrow justify-content-end">Review</a>
                                    </footer>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <!--  -->
                <div class="card-needs">
                    <header class="card-needs__header">
                        <h3 class="heading3 heading3--match">Solutions</h3>

                        <a href="#" class="link">4 Unreviewed</a>
                    </header>
                    <div class="card-needs__content">
                        <div class="row mb-4">
                            <div class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <header class="card-headline__content__header">
                                            <div class="image-block">
                                                <img src="https://sp-images-dev.s3.amazonaws.com/1731059811672de0631dfad.jpeg" alt="">
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">Gamma Core</h5>
                                                <p class="">Partnership Readiness: 9/10</p>
                                            </div>
                                        </header>

                                        <p>Ante in nibh mauris cursus. Scelerisque eu ultrices vitae auctor eu. Sit amet massa vitae tortor condimentum lacinia quis vel eros. Faucibus pulvinar elementum integer enim neque volutpat.</p>

                                        <footer class="card-headline__content__footer">
                                            <div class="rating-section">
                                                <div class="rating">
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class=""></span>
                                                </div>
                                            </div>

                                            <div class="card-headline__author card-headline__author--ai"></div>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <header class="card-headline__content__header">
                                            <div class="image-block">
                                                <img src="https://sp-images-dev.s3.amazonaws.com/1731059811672de0631dfad.jpeg" alt="">
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">Gamma Core</h5>
                                                <p class="">Partnership Readiness: 9/10</p>
                                            </div>
                                        </header>

                                        <p>Ante in nibh mauris cursus. Scelerisque eu ultrices vitae auctor eu. Sit amet massa vitae tortor condimentum lacinia quis vel eros. Faucibus pulvinar elementum integer enim neque volutpat.</p>

                                        <footer class="card-headline__content__footer">
                                            <div class="rating-section">
                                                <div class="rating">
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class=""></span>
                                                </div>
                                            </div>

                                            <div class="card-headline__author">
                                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="">
                                            </div>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <header class="card-headline__content__header">
                                            <div class="image-block">
                                                <img src="https://sp-images-dev.s3.amazonaws.com/1731059811672de0631dfad.jpeg" alt="">
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">Gamma Core</h5>
                                                <p class="">Partnership Readiness: 9/10</p>
                                            </div>
                                        </header>

                                        <p>Ante in nibh mauris cursus. Scelerisque eu ultrices vitae auctor eu. Sit amet massa vitae tortor condimentum lacinia quis vel eros. Faucibus pulvinar elementum integer enim neque volutpat.</p>

                                        <footer class="card-headline__content__footer">
                                            <div class="rating-section">
                                                <div class="rating">
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class=""></span>
                                                </div>
                                            </div>

                                            <div class="card-headline__author card-headline__author--ai"></div>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                            <div class="col">
                                <div class="card-headline">
                                    <div class="card-headline__content">
                                        <header class="card-headline__content__header">
                                            <div class="image-block">
                                                <img src="https://sp-images-dev.s3.amazonaws.com/1731059811672de0631dfad.jpeg" alt="">
                                            </div>
                                            <div>
                                                <h5 class="heading5 heading5--secondary">Gamma Core</h5>
                                                <p class="">Partnership Readiness: 9/10</p>
                                            </div>
                                        </header>

                                        <p>Ante in nibh mauris cursus. Scelerisque eu ultrices vitae auctor eu. Sit amet massa vitae tortor condimentum lacinia quis vel eros. Faucibus pulvinar elementum integer enim neque volutpat.</p>

                                        <footer class="card-headline__content__footer">
                                            <div class="rating-section">
                                                <div class="rating">
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class="rating__current"></span>
                                                    <span class=""></span>
                                                </div>
                                            </div>

                                            <div class="card-headline__author">
                                                <img src="https://app2.dev.switchpitch.com/img/global.e72ae145.png" alt="">
                                            </div>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            Startups:
            <div v-for="startup in startups" :key="startup.id">
                {{startup.name}}
            </div>
        </div>

        <a class="link" @click="getNewAiMatches">Get New Matches</a>

        <MatchMakingModal
            ref="matchMakingModal"
            @updated="getInfo()"
        />
    </div>
</template>

<style scoped>

</style>
